import api from "../../../services/apiClient"
import type { AgencyFormValues } from "../models/agency"

const BASE = "agency"

export const agencyApi = {
  getList: async (params?: Record<string, unknown>) => {
    const { data } = await api.get(BASE, { params })
    return data?.data ?? data
  },
  getById: async (id: number) => {
    const { data } = await api.get(`${BASE}/${id}`)
    return data?.data ?? data
  },
  create: async (values: AgencyFormValues) => {
    const { data } = await api.post(`${BASE}/create`, values)
    return data?.data ?? data
  },
  update: async (id: number, values: Partial<AgencyFormValues>) => {
    const { data } = await api.post(`${BASE}/update/${id}`, values)
    return data?.data ?? data
  },
  delete: async (id: number) => {
    const { data } = await api.delete(`${BASE}/delete/${id}`)
    return data
  },
  uploadMultimedia: async (id: number, type: string, file: File) => {
    const formData = new FormData()
    formData.append("type", type)
    formData.append("file", file)
    const { data } = await api.post(`${BASE}/upload-multimedia/${id}`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    return data?.data ?? data
  },
  removeMultimedia: async (id: number, type: string) => {
    const { data } = await api.post(`${BASE}/remove-multimedia/${id}`, { type })
    return data?.data ?? data
  },
}
